var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorForAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6199_2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20C19.1944 20 23 16.1944 23 11.5C23 6.80558 19.1944 3 14.5 3C9.80558 3 6 6.80558 6 11.5C6 16.1944 9.80558 20 14.5 20Z",
    fill: "#FD4C5C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.753 14.5001L14.9066 7.29362C14.8594 7.20502 14.7891 7.1309 14.7031 7.07918C14.6171 7.02746 14.5187 7.00009 14.4183 7C14.3181 7.00005 14.2197 7.02731 14.1337 7.07887C14.0478 7.13042 13.9774 7.20435 13.9301 7.29276L10.0659 14.4997C10.0206 14.5841 9.99793 14.6788 10.0001 14.7746C10.0024 14.8704 10.0294 14.9639 10.0786 15.0461C10.1278 15.1284 10.1974 15.1964 10.2808 15.2436C10.3641 15.2909 10.4583 15.3157 10.5541 15.3157H18.2635C18.3593 15.3156 18.4534 15.2908 18.5367 15.2436C18.6201 15.1964 18.6897 15.1285 18.739 15.0464C18.7883 14.9643 18.8155 14.8708 18.818 14.7751C18.8204 14.6794 18.798 14.5846 18.753 14.5001ZM14.4179 14.2069C14.3082 14.2067 14.2011 14.1741 14.11 14.113C14.0189 14.0519 13.948 13.9652 13.9062 13.8638C13.8644 13.7624 13.8537 13.6509 13.8752 13.5434C13.8968 13.4359 13.9498 13.3372 14.0275 13.2598C14.1052 13.1824 14.2041 13.1298 14.3117 13.1086C14.4193 13.0874 14.5308 13.0986 14.632 13.1408C14.7332 13.183 14.8197 13.2543 14.8804 13.3456C14.9411 13.4369 14.9734 13.5442 14.9731 13.6538C14.9728 13.8008 14.9141 13.9416 14.81 14.0453C14.7059 14.149 14.5649 14.2071 14.4179 14.2069ZM14.9731 11.9985C14.9731 12.1455 14.9147 12.2865 14.8108 12.3905C14.7068 12.4945 14.5658 12.5529 14.4188 12.5529C14.2717 12.5529 14.1307 12.4945 14.0268 12.3905C13.9228 12.2865 13.8644 12.1455 13.8644 11.9985V9.78097C13.8644 9.63394 13.9228 9.49293 14.0268 9.38897C14.1307 9.285 14.2717 9.22659 14.4188 9.22659C14.5658 9.22659 14.7068 9.285 14.8108 9.38897C14.9147 9.49293 14.9731 9.63394 14.9731 9.78097V11.9985Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6199_2041",
    x: 0,
    y: 0,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6199_2041"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6199_2041",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorForAdmin);
export default __webpack_public_path__ + "static/media/error-for-admin.79626ed08df1a9f340f6bf4adf37d682.svg";
export { ForwardRef as ReactComponent };